import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  stepLine: {
    width: '30px',
    [theme.breakpoints.down('sm')]: {
      width: '8%'
    }
  },
  arrowLine: {
    position: 'relative',
    top: '35px',
    zIndex: 1,
    width: '30px',
    height: '10px',
    [theme.breakpoints.down('sm')]: {
      top: '35px',
      width: '100%',
      height: '100%'
    }
  },
  arrow: {
    display: 'inline-block',
    width: '8px',
    height: '8px',
    margin: '0 10px',
    borderTop: '2px solid #2EC1B4',
    borderRight: '2px solid #2EC1B4',
    transform: 'rotate(45deg)',
    position: 'relative',
    top: '-40px',
    right: '-19px',
    zIndex: 2
  }
});

const enhance = compose(pure);

const button = enhance(({ classes }) => {
  return (
    <div className={classes.stepLine}>
      <img
        src={`${process.env.PUBLIC_URL}/images/arrow.png`}
        alt="arrow"
        className={classes.arrowLine}
      />
    </div>
  );
});

export default withStyles(styles)(button);
